/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poparce.ru/api/dewu/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BuyerOrderFilterType } from '../models';
/**
 * ExportApi - axios parameter creator
 * @export
 */
export const ExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Выгрузка заказов
         * @param {string} clientId 
         * @param {number} pageSize Размер страницы (от 5 до 20)
         * @param {BuyerOrderFilterType} type Тип фильтра заказов. Возможные значения:  - **1** - ожидают оплаты - **2** - ожидают отправки - **3** - принято  - **4** - все заказы - **5** - следующий по порядку
         * @param {string} [lastId] ID последнего элемента для пагинации
         * @param {string} [keyword] Ключевое слово для поиска заказов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerExportInExcel: async (clientId: string, pageSize: number, type: BuyerOrderFilterType, lastId?: string, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('exportControllerExportInExcel', 'clientId', clientId)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('exportControllerExportInExcel', 'pageSize', pageSize)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('exportControllerExportInExcel', 'type', type)
            const localVarPath = `/export/export-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (lastId !== undefined) {
                localVarQueryParameter['lastId'] = lastId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            if (clientId != null) {
                localVarHeaderParameter['client-id'] = String(clientId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportApi - functional programming interface
 * @export
 */
export const ExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Выгрузка заказов
         * @param {string} clientId 
         * @param {number} pageSize Размер страницы (от 5 до 20)
         * @param {BuyerOrderFilterType} type Тип фильтра заказов. Возможные значения:  - **1** - ожидают оплаты - **2** - ожидают отправки - **3** - принято  - **4** - все заказы - **5** - следующий по порядку
         * @param {string} [lastId] ID последнего элемента для пагинации
         * @param {string} [keyword] Ключевое слово для поиска заказов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerExportInExcel(clientId: string, pageSize: number, type: BuyerOrderFilterType, lastId?: string, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerExportInExcel(clientId, pageSize, type, lastId, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportControllerExportInExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExportApi - factory interface
 * @export
 */
export const ExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportApiFp(configuration)
    return {
        /**
         * 
         * @summary Выгрузка заказов
         * @param {string} clientId 
         * @param {number} pageSize Размер страницы (от 5 до 20)
         * @param {BuyerOrderFilterType} type Тип фильтра заказов. Возможные значения:  - **1** - ожидают оплаты - **2** - ожидают отправки - **3** - принято  - **4** - все заказы - **5** - следующий по порядку
         * @param {string} [lastId] ID последнего элемента для пагинации
         * @param {string} [keyword] Ключевое слово для поиска заказов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerExportInExcel(clientId: string, pageSize: number, type: BuyerOrderFilterType, lastId?: string, keyword?: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.exportControllerExportInExcel(clientId, pageSize, type, lastId, keyword, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportApi - object-oriented interface
 * @export
 * @class ExportApi
 * @extends {BaseAPI}
 */
export class ExportApi extends BaseAPI {
    /**
     * 
     * @summary Выгрузка заказов
     * @param {string} clientId 
     * @param {number} pageSize Размер страницы (от 5 до 20)
     * @param {BuyerOrderFilterType} type Тип фильтра заказов. Возможные значения:  - **1** - ожидают оплаты - **2** - ожидают отправки - **3** - принято  - **4** - все заказы - **5** - следующий по порядку
     * @param {string} [lastId] ID последнего элемента для пагинации
     * @param {string} [keyword] Ключевое слово для поиска заказов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportApi
     */
    public exportControllerExportInExcel(clientId: string, pageSize: number, type: BuyerOrderFilterType, lastId?: string, keyword?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportControllerExportInExcel(clientId, pageSize, type, lastId, keyword, options).then((request) => request(this.axios, this.basePath));
    }
}

